import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TextRegular } from 'UiKit/typography';
import BadgeStatus from 'View/report-attendance-host-detail/component/badge-status';

import styles from './styles.module.css';

const ColumnStartLivestream = ({ value }) => {
  return (
    <Box className={styles['column-start-livestream__container']}>
      <TextRegular>{value?.time !== '-' ? moment(value?.time).format('HH:mm:ss DD/MM/YY') : value?.time}</TextRegular>
      <BadgeStatus status={value?.status} />
    </Box>
  );
};

export default ColumnStartLivestream;
